import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import classes from './styles.module.css';
import { SliderItemType } from '../data';
import { isRTL } from 'src/utils/global';



interface ItemProp {
    item: SliderItemType
}

const Item: FC<ItemProp> = ({ item }) => {
    const { i18n, t } = useTranslation(['home']);

    return (
        <div className={`${classes.item} ${isRTL() && classes.rtl}`}>
            <div className={classes.overlay}>
                <div className='container'>
                    <div className={classes.content}>
                        <h2>
                            {item.name[i18n.language] || item.name.en}
                        </h2>
                        <p>
                            {item.overview[i18n.language] || item.name.en}
                        </p>

                    </div>
                </div>
            </div>

            <div className={classes.img__con}>
                <img src={item.img} alt={"Elentsar Alzaher"} />
            </div>

        </div>
    )
}

export default Item;